import {
  Drawer,
  List,
  ListItemButton,
  ListItemText,
  Tooltip,
  Box,
  Divider,
  Collapse,
  ListItemIcon,
  useMediaQuery,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";

import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import ContactsIcon from "@mui/icons-material/Contacts";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";

import { useNavigate, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";

const Sidebar = ({ open, toggleDrawer }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const [whatsappOpen, setWhatsappOpen] = useState(false);
  const [contactOpen, setContactOpen] = useState(false);

  useEffect(() => {
    if (location.pathname.includes("whatsapp")) setWhatsappOpen(true);
    if (location.pathname.includes("contact")) setContactOpen(true);
  }, [location.pathname]);

  const isActive = (path) => location.pathname === path;

  const menuButtonStyle = (path) => ({
    bgcolor: isActive(path) ? "#1f2937" : "transparent",
    borderLeft: isActive(path) ? "4px solid #ff6600" : "4px solid transparent",
    borderRadius: "10px",
    margin: "6px 8px",
    height: 48,
    color: "white",
    "&:hover": {
      bgcolor: "#243447",
      borderLeft: "4px solid #ff6600",
    },
    transition: "0.3s",
  });

  const iconStyle = (path) => ({
    minWidth: 40,
    color: isActive(path) ? "#ff6600" : "#cbd5e1",
    fontSize: "22px",
  });

  return (
    <Drawer
      variant={isMobile ? "temporary" : "permanent"}
      open={open}
      onClose={toggleDrawer}
      ModalProps={{
        keepMounted: true, // improves performance on mobile
      }}
      sx={{
        width: open ? 240 : 75,
        flexShrink: 0,
        "& .MuiDrawer-paper": {
          width: open ? 240 : 75,
          background: "linear-gradient(180deg,#111827,#1e293b,#243447,#2f4054)",
          color: "white",
          transition: "width 0.35s ease",
          overflowX: "hidden",
          display: "flex",
          flexDirection: "column",
        },
      }}
    >
      {/* Logo Section */}
      <Box sx={{ textAlign: "center", py: 1, bgcolor: "#ffffff", mb: 1 }}>
        <img src="/logo.jpeg" alt="logo" width={open ? "130px" : "45px"} />
      </Box>

      {/* Menu List */}
      <Box sx={{ flexGrow: 1 }}>
        <List>
          {/* Dashboard */}
          <Tooltip title={!open ? "Dashboard" : ""} placement="right">
            <ListItemButton
              sx={menuButtonStyle("/dashboard")}
              onClick={() => {
                navigate("/dashboard");
                if (isMobile) toggleDrawer();
              }}
            >
              <ListItemIcon sx={iconStyle("/dashboard")}>
                <HomeOutlinedIcon />
              </ListItemIcon>
              {open && <ListItemText primary="Dashboard" />}
            </ListItemButton>
          </Tooltip>

          {/* WhatsApp */}
          <Tooltip title={!open && "WhatsApp"} placement="right">
            <ListItemButton
              sx={menuButtonStyle("")}
              onClick={() => setWhatsappOpen(!whatsappOpen)}
            >
              <ListItemIcon sx={iconStyle("")}>
                <WhatsAppIcon />
              </ListItemIcon>
              {open && <ListItemText primary="WhatsApp" />}
              {open && (whatsappOpen ? <ExpandLess /> : <ExpandMore />)}
            </ListItemButton>
          </Tooltip>

          <Collapse in={whatsappOpen && open}>
            <List disablePadding>
              {[
                { name: "Send WhatsApp", path: "/send-whatsapp" },
                { name: "WhatsApp History", path: "/whatsapp-history" },
              ].map((item, index) => (
                <ListItemButton
                  key={index}
                  sx={menuButtonStyle(item.path)}
                  onClick={() => {
                    navigate(item.path);
                    if (isMobile) toggleDrawer();
                  }}
                >
                  <ListItemIcon sx={iconStyle(item.path)}>
                    <WhatsAppIcon />
                  </ListItemIcon>
                  <ListItemText primary={item.name} />
                </ListItemButton>
              ))}
            </List>
          </Collapse>

          {/* Contact Management */}
          <Tooltip title={!open && "Contact Management"} placement="right">
            <ListItemButton
              sx={menuButtonStyle("")}
              onClick={() => setContactOpen(!contactOpen)}
            >
              <ListItemIcon sx={iconStyle("")}>
                <ContactsIcon />
              </ListItemIcon>
              {open && <ListItemText primary="Contact Mgmt" />}
              {open && (contactOpen ? <ExpandLess /> : <ExpandMore />)}
            </ListItemButton>
          </Tooltip>

          <Collapse in={contactOpen && open}>
            <List disablePadding>
              {[
                { name: "Contact Division", path: "/contacts-division" },
                { name: "Active Contacts", path: "/active-contacts" },
                { name: "Inactive Contacts", path: "/inactive-contacts" },
              ].map((item, index) => (
                <ListItemButton
                  key={index}
                  sx={menuButtonStyle(item.path)}
                  onClick={() => {
                    navigate(item.path);
                    if (isMobile) toggleDrawer();
                  }}
                >
                  <ListItemIcon sx={iconStyle(item.path)}>
                    <ContactsIcon />
                  </ListItemIcon>
                  <ListItemText primary={item.name} />
                </ListItemButton>
              ))}
            </List>
          </Collapse>
        </List>
      </Box>

      <Divider sx={{ opacity: 0.1 }} />

      <Box
        sx={{
          textAlign: "center",
          py: 1.5,
          background: "#111827",
          fontSize: open ? "12px" : "10px",
          opacity: 0.7,
        }}
      >
        {open && "© 2025 Digital Jayesh"}
      </Box>
    </Drawer>
  );
};

export default Sidebar;
